import { motion } from "framer-motion";
import { WHATSAPP_LINK } from "@/constants/config";

export const TopBar = () => {
  const handleClick = () => {
    if (typeof window !== "undefined") {
      if (typeof window.fbq === "function") window.fbq("track", "Lead");
      const url = new URL(window.location.href);
      url.searchParams.set("first_access", "joined");
      window.history.pushState({}, "", url.toString());
      window.dispatchEvent(new CustomEvent("mik-joined"));
    }
  };

  return (
    <motion.a
      data-testid="top-bar-cta"
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      initial={{ y: -30 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-x-0 top-0 z-40 flex min-h-[40px] items-center justify-center gap-1.5 bg-[#0f93cc] px-3 py-2 text-center text-[11px] font-semibold text-white safe-top sm:min-h-[44px] sm:text-xs"
    >
      <span className="truncate">🎓 MIK First Access is open —</span>
      <span className="shrink-0 underline underline-offset-2">Join Now →</span>
    </motion.a>
  );
};
